/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/AppContext';
import { AccessType } from '../types/Types';
import logo_caprabo from '../assets/images/cpb/logo-caprabo.svg';
import iconFB from '../assets/images/cpb/rs_fb.png_466550625.png';
import iconYutube from '../assets/images/cpb/rs_yt.png_163290697.png';
import iconTwitter from '../assets/images/cpb/rs_t.png_466550625.png';
import iconInsta from '../assets/images/cpb/rs_i.png_466550625.png';
import iconFlicker from '../assets/images/cpb/rs_f.png_466550648.png';
import { FooterConstants } from '../utils/FooterConstants';

interface Props {
  eventClickBarOptions: any;
  eventClickScrollLeft: any;
  eventClickAcordion: any;
  footerLink: AccessType[];
  getUrlLink: any;
}

const FooterCaprabo: FC<Props> = (props) => {
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const {
    eventClickBarOptions,
    eventClickScrollLeft,
    eventClickAcordion,
    footerLink,
    getUrlLink,
  } = props;
  const [showRcsList, setShowRcsList] = useState<boolean>(false);
  const [showJoinUsList, setShowJoinUsList] = useState<boolean>(false);
  const [showKnowCapraboList, setShowKnowCapraboList] = useState<boolean>(
    false,
  );

  return (
    <footer>
      <div className="container-fluid secciones-footer">
        <div className=" ">
          <div className="row">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={`col-md-3 menu ${showRcsList ? 'active_menu' : ''}`}
              onClick={() => setShowRcsList(!showRcsList)}
            >
              <h4 className="title">{t('footer.rsc')}</h4>
              <div className="col-uno-rsc">
                <ul className="footer-list">
                  <li>
                    <a
                      href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                        'link.compromiso-responsable',
                      )}`}
                    >
                      {' '}
                      {t('footer.compromisoResponsable')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${FooterConstants.URL_ELIGE_BUENO_ELIGE_SANO}${dataApp?.lang}`}
                    >
                      {' '}
                      {t('footer.eligeBuenoEligeSano')}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-dos-rsc">
                <ul className="footer-list ">
                  <li>
                    <a
                      href={`${FooterConstants.URL_MICRODONACIONESCAPRABO}${dataApp?.lang}`}
                    >
                      {' '}
                      {t('footer.microdonaciones')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${FooterConstants.URL_SOSTENIBILITATCAPRABO}${dataApp?.lang}`}
                    >
                      {' '}
                      {t('footer.sostenibilidades')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={`col-md-3 menu ${showJoinUsList ? 'active_menu' : ''}`}
              onClick={() => setShowJoinUsList(!showJoinUsList)}
            >
              <h4 className="title">{t('footer.formaParteCaprabo')}</h4>
              <ul className="footer-list ">
                <li>
                  <a
                    href={`${FooterConstants.URL_FRANQUICIAS}${dataApp?.lang}`}
                  >
                    {' '}
                    {t('footer.franquicias')}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.trabaja-nosotros',
                    )}`}
                  >
                    {t('footer.trabajaAki')}
                  </a>
                </li>
              </ul>
            </div>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={`col-md-3 menu ${
                showKnowCapraboList ? 'active_menu' : ''
              }`}
              onClick={() => setShowKnowCapraboList(!showKnowCapraboList)}
            >
              <h4 className="title">{t('footer.conoceCaprabo')}</h4>
              <ul className="footer-list ">
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.caprabo',
                    )}`}
                  >
                    {t('footer.caprabo')}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.sala-prensa',
                    )}`}
                  >
                    {t('footer.salaPrensa')}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 box-atencion-cliente">
              <div className="atencion-cliente ">
                <div className="img-atencion-cliente equal-height-zero" />
                <h4>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.ccTitle',
                    )}`}
                    title="Atención al cliente"
                  >
                    {t('footer.ccTitle')}
                  </a>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="enlaces-footer">
          <div className="row">
            <div className="col-md-2 u-text-center">
              <a
                href={`${process.env.REACT_APP_CLUB_CAPRABO}`}
                className="idioma-es"
              >
                <img
                  className="img-responsive center-block"
                  src={logo_caprabo}
                  alt="Caprabo contigo"
                />
              </a>
            </div>
            <div className="col-md-7 u-text-center">
              <ul className="">
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.ccTitle',
                    )}`}
                  >
                    {t('footer.ccTitle')}
                  </a>
                </li>
                <li> | </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.localizador-de-supermercados',
                    )}`}
                  >
                    {t('footer.localizadorSupermercados')}
                  </a>
                </li>
                <li> | </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.copyright',
                    )}`}
                  >
                    {t('footer.copyright')}
                  </a>
                </li>
                <li> | </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.politicas',
                    )}`}
                  >
                    {t('footer.politicas')}
                  </a>
                </li>
                <li> | </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.aviso-legal',
                    )}`}
                  >
                    {t('footer.avisoLegal')}
                  </a>
                </li>
                <li> | </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.preguntas-frecuentes',
                    )}`}
                  >
                    {t('footer.faq')}
                  </a>
                </li>
                <li> | </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.condiciones-club-caprabo',
                    )}`}
                  >
                    {t('footer.condicionesClub')}
                  </a>
                </li>
                <li> | </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_CLUB_CAPRABO}${t(
                      'link.politica-de-privacidad',
                    )}`}
                  >
                    {t('footer.politicasProteccionDatos')}
                  </a>
                </li>
                <li> -</li>
                <li> {t('footer.derechosReservados')}</li>
              </ul>
            </div>
            <div className="col-md-3 u-text-center rede-social">
              <a
                href={`${FooterConstants.URL_FACEBOOK_CAPRABO}`}
                target="_blank"
                rel="noopener noreferrer"
                className="idioma-es"
              >
                <img alt="fb" className="" src={iconFB} />{' '}
              </a>
              <a
                href={`${FooterConstants.URL_TWITTER_CAPRABO}`}
                target="_blank"
                rel="noopener noreferrer"
                className="idioma-es"
              >
                <img alt="tw" className="" src={iconTwitter} />{' '}
              </a>
              <a
                href={`${FooterConstants.URL_YOUTUBE_CAPRABO}`}
                target="_blank"
                rel="noopener noreferrer"
                className="idioma-es"
              >
                <img alt="yt" className="" src={iconYutube} />{' '}
              </a>
              <a
                href={`${FooterConstants.URL_FLICKR_CAPRABO}`}
                target="_blank"
                rel="noopener noreferrer"
                className="idioma-es"
              >
                <img alt="f" className="" src={iconFlicker} />{' '}
              </a>
              <a
                href={`${FooterConstants.URL_INSTAGRAM_CAPRABO}`}
                target="_blank"
                rel="noopener noreferrer"
                className="idioma-es"
              >
                <img alt="i" className="" src={iconInsta} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterCaprabo;
